export const SKULL_CUSTOM_FOOTER_PORTAL_ROOT_ID = 'SKULL_CUSTOM_FOOTER_PORTAL_ROOT_ID';
